// @flow

import { connect } from 'react-redux';

import DashboardActions from 'app/dashboard/DashboardActions';
import TaskHistoryActions from 'app/history/TaskHistoryActions';
import ZapWarning from 'app/dashboard/components/ZapWarning';
import { HELD_STATUSES_URL } from 'app/dashboard/utils/constants';
import { addTruthyParamsToUrl } from 'app/common/utils/UrlUtils';
import {
  getStaleAuthServiceNamesByZap,
  selectHeldTasksStartsExpiringOnByZapId,
  selectHeldTasksTotalByZapId,
} from 'app/dashboard/Selectors';

import type { Dispatch } from 'app/common/types';
import type { ServicesMap } from 'app/service/types';

type OwnProps = {
  services: ServicesMap,
};

type StateProps = {
  zapId?: number | string,
  staleAuthServiceNamesByZap?: Array<string>,
  heldTasksStartsExpiringOn?: string,
  heldTasksCount?: number,
};

const mapStateToProps = (state, props): StateProps => {
  const { zapId, services } = props;
  const heldTasksStartsExpiringOn = selectHeldTasksStartsExpiringOnByZapId(
    state,
    zapId
  );
  const heldTasksCount = selectHeldTasksTotalByZapId(state, zapId);

  const staleAuthServiceNamesByZap = getStaleAuthServiceNamesByZap(
    zapId,
    services,
    state
  );

  return {
    zapId,
    heldTasksStartsExpiringOn,
    heldTasksCount,
    staleAuthServiceNamesByZap,
  };
};

const mapDispatchToProps = (
  dispatch: Dispatch,
  props: OwnProps & StateProps
) => ({
  onHeldTaskLinkClick() {
    const { zapId } = props;
    const heldTasksUrl = addTruthyParamsToUrl(HELD_STATUSES_URL, {
      root_id: zapId,
    });

    dispatch(TaskHistoryActions.routeToThenSelectAll(heldTasksUrl));
  },
  onFixItLinkClick() {
    const { services } = props;
    dispatch(DashboardActions.toggleHeldTasksBannerAndCreateSnapshot(services));
  },
});

const ZapWarningContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ZapWarning);

export default ZapWarningContainer;
